
import ClickOutside from "vue-click-outside";
import { isEmpty } from "@utils";
import DefinitionContent from "./DefinitionContent.vue";
import { getWordDefinition } from "@/common/services/wordDefinitionService";

export default {
	name: "Definition",
	components: { DefinitionContent },
	directives: {
		ClickOutside,
	},
	inject: ["isCompactMode"],
	props: {
		word: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			definitionIsOpen: false,
			definitionIsLoading: false,
			definition: "",
			definitionType: "",
		};
	},
	computed: {
		hasDefinition() {
			return !isEmpty(this.definition) || !isEmpty(this.definitionType);
		},
	},
	methods: {
		onButtonClick() {
			if (!this.definitionIsOpen) {
				this.getDefinition();
			}
			this.definitionIsOpen = !this.definitionIsOpen;
		},
		onWindowCloseButtonClick() {
			this.definitionIsOpen = false;
		},
		onDefinitionWindowClickOutside(e) {
			if (e.composedPath().includes(this.$refs?.button)) {
				return false;
			}

			this.definitionIsOpen = false;
		},
		getDefinition() {
			this.definitionIsLoading = true;

			getWordDefinition(this.$axios, this.$config, this.word)
				.then(({ sense, partOfSentence }) => {
					this.definition = sense;
					this.definitionType = partOfSentence;
				})
				.catch(() => {
					this.$emit("onDefinitionNotFound");
					this.definition = "";
					this.definitionType = "";
				})
				.finally(() => {
					this.definitionIsLoading = false;
				});
		},
	},
};
